module.exports = __webpack_public_path__ + "img/87.f7572ffe.jpg";